export const RAIL_WIDTH_CSS_VAR = '--grove-rail-width';

const RESERVED = `var(${RAIL_WIDTH_CSS_VAR}, 0px)`;

export const APP_SHELL_WIDTH = `calc(100% - ${RESERVED})`;

export const APP_RIGHT_EDGE = RESERVED;

/** For fixed elements that also need their own inset from that edge. */
export const appRightEdge = (inset: number) => `calc(${RESERVED} + ${inset}px)`;
